import React from 'react';
import './AfaziDiscountSection.css';
import afaziImage from '../../../assets/images/2.jpg'; // Görsel yolu

const AfaziDiscountSection = () => {
  return (
    <section 
      className="trial-section"
      style={{ backgroundImage: `url(${afaziImage})` }}
    >
      <div className="trial-overlay">
        <a href="#talep-formu" className="trial-notice">
          Afazili/Afazili Yakını olanlar için <br />
          indirimli kayıt fırsatına <br />
          ulaşmak için iletişime geç!
        </a>
      </div>
    </section>
  );
};

export default AfaziDiscountSection;
